import * as React from "react";
import { Grid } from "@mui/material";

// Needed components
import GenericModal from "components/GenericModal/GenericModal";

interface IComplianceScorecardAssistanceModalProps {
  modalOpen: boolean;
  modalTitle: string;
  onClose: any;
  content: any;
}

const ComplianceScorecardAssistanceModal: React.FunctionComponent<IComplianceScorecardAssistanceModalProps> = props => {
  return (
    <GenericModal
      open={props.modalOpen}
      onClose={props.onClose}
      contentWidth={50}
      title={props.modalTitle}
      content={<Grid container>{props.content}</Grid>}
    />
  );
};

export default ComplianceScorecardAssistanceModal;
